export const sliderSettings = (numSlides) => {
  return {
    centerMode: true,
    dots: false,
    infinite: numSlides > 1,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    draggable: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          centerMode: true,
          arrows: false,
          draggable: true,
          infinite: numSlides > 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          arrows: false,
          draggable: true,
          infinite: numSlides > 1,
        },
      },
    ],
  };
};



// WEBPACK FOOTER //
// ./src/screens/Products/components/ProductCarousel/constants.js